import React, {Component} from 'react';
import { NavLink, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

class HeaderRight extends Component {

    mapRoutes(key) {
        if(key.hidden) {
          return;
        }
        return (<li key={key}><NavLink className="block" key={key} to={key.url}>{key.title}</NavLink></li>)
                        
    }

    render() {
       
        return (
            <div className="menu menu--top-right">
                <ul>
                   
                    <li>
                        <NavLink to="/content/over-mijndp">
                            <div className="badge badge--question">
                                <i className="fa fa-question-circle"></i>
                            </div>
                        </NavLink>
                    </li>
                   {/* <li>
                        <div className="badge badge--empty">
                            
                        </div>
                    </li>*/}
                    <li>
                        <div className="badge badge--user">
                            <div className="user user--name">
                                {this.props.user ?  this.props.user.user_profile ? this.props.user.user_profile.name : null : null}
                            </div> 
                            <ul className="user__menu"> 
                                {this.props.user.profileRoutes ? this.props.user.profileRoutes.map(this.mapRoutes) : ''}
                            </ul>
                        </div>

                    </li>

                </ul>
                
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderRight));


// WEBPACK FOOTER //
// ./src/components/Layout/Header/HeaderRight/index.js